<template>
  <router-link to="/">
    <div class="flex items-center">
      <img 
        src="/images/logo-horizontal.webp"
        alt="AutoVolt.ai"
        class="w-auto logo-padrao"
        style="height: 40px !important; margin-top: -5px"
      />
      <img
        src="/images/logo-horizontal-claro.png"
        alt="AutoVolt.ai"
        class="w-auto logo-claro"
        style="height: 40px !important; margin-top: -5px"
      />
    </div>
  </router-link>
</template>
